import React from 'react'
import { Radio } from 'antd'
import { StyledRadioGroup } from './styles'

const RadioButtonGroup = ({ options, value, onChange }) => {
  const getAbbreviatedLabel = (label) => {
    if (label === 'Communication Assessment') return 'Comm. Assmt.'
    if (label === 'Behavioral Assessment') return 'Behavioral Assmt.'
    if (label === 'Cognitive Aptitude') return 'Cognitive Aptitude'
    if (label === 'Technical Assessment - MCQ') return 'Tech.Assmt. - MCQ'
    if (label === 'Technical Assessment - Coding') return 'Tech.Assmt. - Coding'
    return label
  }

  return (
    <StyledRadioGroup value={value} onChange={onChange}>
      {options.map(option => (
        <Radio key={option.value} value={option.value}>
          {getAbbreviatedLabel(option.label)}
        </Radio>
      ))}
    </StyledRadioGroup>
  )
}

export default RadioButtonGroup
